<script lang="ts">
  import EventBanner from "./event-banner.svelte";
  import PlaceBanner from "./place-banner.svelte";
  import { getNow, getTimeZone } from "../data/clock";
  import { isFuture } from "../support/dates";
  import { reify } from "../domain/hours";
  import { createEventDispatcher } from "svelte";
  import type { Event, Hours, Maybe, Place } from "../types";
  import type { QueryParams } from "../support/links";

  export let time = getNow();
  export let timeZone = getTimeZone();
  export let event: Maybe<Event> = null;
  export let hours: Hours[] = [];
  export let place: Maybe<Place> = null;
  export let linkBuilder: (query?: QueryParams) => string;

  $: occurences = hours
    .flatMap((eventHours) => {
      return reify(eventHours, $time, 0, $timeZone);
    })
    .filter((occurence) => {
      return isFuture(occurence.until, $time);
    });

  const dispatch = createEventDispatcher();

  function onNavigate() {
    dispatch("navigate");
  }
</script>

{#if event && occurences.length > 0}
  <EventBanner
    {event}
    {place}
    {occurences}
    {linkBuilder}
    {time}
    {timeZone}
    on:navigate={onNavigate}
  />
{:else if place}
  <PlaceBanner {place} {linkBuilder} {time} on:navigate={onNavigate} />
{/if}
